var THREE = require("three");
const config = require("../config.js");
require("./utils.js");
var colors = {};
module.exports.getColor = function (color, mlt) {
  var tmpIndx = color + "-" + (mlt || "");
  var tmpCol = colors[tmpIndx];
  if (!tmpCol) {
    tmpCol = new THREE.Color(color);
    if (mlt) {
      tmpCol.multiplyScalar(mlt);
    }
    var I = {};
    tmpCol.getHSL(I);
    I.s = Math.min(1, I.s * 1.5);
    tmpCol.setHSL(I.h, I.s, I.l);
    colors[tmpIndx] = tmpCol;
  }
  return tmpCol;
};
module.exports.colorize = function (E, F, G) {
  F = G || module.exports.getColor(F);
  for (var H = 0; H < E.faces.length; ++H) {
    E.faces[H].vertexColors[0] = F;
    E.faces[H].vertexColors[1] = F;
    E.faces[H].vertexColors[2] = F;
  }
};
var v;
function resizeTexture(geometry, scaleX, scaleY, scaleMlt) {
  var tex_coords;
  var tex_scale = new THREE.Vector2(scaleX, scaleY).multiplyScalar(
    scaleMlt || 1,
  );
  for (var ii = 0; ii < geometry.faceVertexUvs.length; ii++) {
    tex_coords = geometry.faceVertexUvs[ii];
    for (var face_idx = 0; face_idx < tex_coords.length; face_idx++) {
      var scaled_coord;
      for (var i = 0; i < 3; i++) {
        (scaled_coord = tex_coords[face_idx][i].multiply(tex_scale)).x =
          0.5 + scaled_coord.x - tex_scale.x / 2;
      }
    }
  }
}
function x(E, F, G, H, I, J) {
  return E >= G - I && E <= G + I && F >= H - J && F <= H + J;
}
var y = [];
var z = ["a", "b", "c", "d"];
module.exports.generatePlane = function (E, F, G, H, I, J) {
  E *= G.ratio || 1;
  var K =
    (G.scale ? E + "_" + F + "_" : "") +
    (G.scale || "s") +
    (G.tilesX || "x") +
    (G.tilesZ || "z") +
    (G.noise ? H + "_" + I + "_" + J : "n") +
    (G.colr == null ? "c" : G.colr) +
    (G.dark || "d");
  if (!(v = y[K])) {
    v = new THREE.PlaneGeometry(1, 1, G.tilesX || 1, G.tilesZ || 1);
    if (G.noise) {
      var L = {};
      var N = G.margin || 0;
      for (var O = 0; O < v.vertices.length; ++O) {
        var P = v.vertices[O].x;
        var Q = v.vertices[O].y;
        if (!G.pinEdges || (P != -0.5 && P != 0.5 && Q != -0.5 && Q != 0.5)) {
          if (G.objects) {
            for (var R = 0; R < G.objects.length; ++R) {
              if (
                G.objects[R].y - G.objects[R].height <= I + 0.1 &&
                G.objects[R].y + G.objects[R].height > I + G.noise &&
                x(
                  J + -Q * E * 2,
                  H + P * F * 2,
                  G.objects[R].z,
                  G.objects[R].x,
                  G.objects[R].length + N,
                  G.objects[R].width + N,
                )
              ) {
                v.vertices[O].z = Math.random() * G.noise + 1;
                L[O] = module.exports.getColor(G.colr, 0.6);
                break;
              }
            }
          } else {
            v.vertices[O].z = Math.random() * G.noise;
          }
        }
        L[O] ||= module.exports.getColor(G.colr);
      }
      for (O = 0; O < v.faces.length; O++) {
        var T = v.faces[O];
        var U = 0;
        for (var V = 0; V < 3; V++) {
          T.vertexColors[V] = L[T[z[V]]];
          if (v.vertices[T[z[V]]].z <= 0) {
            U++;
          }
        }
        if (U >= 3) {
          delete v.faces[O];
        }
      }
      v.faces = v.faces.filter(function (W) {
        return W;
      });
      v.elementsNeedUpdate = true;
    } else {
      module.exports.colorize(
        v,
        null,
        module.exports.getColor(G.colr || 16777215, G.dark || 1),
      );
    }
    if (G.scale) {
      resizeTexture(v, F / config.worldUV, E / config.worldUV, G.scale);
    }
    v.computeVertexNormals();
    y[K] = v;
  }
  return v;
};
var A = [];
module.exports.generateCube = function (E, F, G, H, I) {
  E = E || [1, 1, 1, 1, 1, 1];
  I.flipp = (F > G || H > G) && I.src == "floor_0";
  I.flippW = F > H && I.src == "floor_0";
  var J =
    (I.scale ? F + "_" + G + "_" + H + "_" : "") +
    (I.colr == null ? "" : I.colr) +
    (I.scale || "") +
    (I.flippW ? "flw" : "fnw") +
    (I.flipp ? "fl" : "fn") +
    (I.amb || "") +
    (I.fAmb || "") +
    (I.useScale || "");
  for (var K = 0; K < E.length; ++K) {
    J += "_" + E[K];
  }
  if (!(v = A[J])) {
    I.colr = I.colr == null ? 16777215 : I.colr;
    var L = module.exports.getColor(I.colr);
    var M = I.amb ? module.exports.getColor(I.colr, I.amb) : L;
    if (I.fAmb) {
      var N = L;
      L = M;
      M = N;
    }
    v = new THREE.Geometry();
    var O;
    var P = [];
    if (E[0]) {
      (O = new THREE.PlaneGeometry(1, 1)).rotateY(Math.PI / 2);
      if (I.flipp) {
        O.rotateX(Math.PI / 2);
      }
      O.translate(0.5, 0.5, 0);
      O.faces[0].vertexColors = [L, M, L];
      O.faces[1].vertexColors = [M, M, L];
      if (I.scale) {
        resizeTexture(
          O,
          (I.flipp ? G : H) / config.worldUV,
          (I.flipp ? H : G) / config.worldUV,
          I.scale,
        );
      }
      P.push(O);
    }
    if (E[1]) {
      (O = new THREE.PlaneGeometry(1, 1)).rotateY(-Math.PI / 2);
      if (I.flipp) {
        O.rotateX(Math.PI / 2);
      }
      O.translate(-0.5, 0.5, 0);
      O.faces[0].vertexColors = [L, M, L];
      O.faces[1].vertexColors = [M, M, L];
      if (I.scale) {
        resizeTexture(
          O,
          (I.flipp ? G : H) / config.worldUV,
          (I.flipp ? H : G) / config.worldUV,
          I.scale,
        );
      }
      P.push(O);
    }
    if (E[2]) {
      (O = new THREE.PlaneGeometry(1, 1)).rotateX(-Math.PI / 2);
      if (I.flippW) {
        O.rotateY(Math.PI / 2);
      }
      O.translate(0, 1, 0);
      O.faces[0].vertexColors = [L, L, L];
      O.faces[1].vertexColors = [L, L, L];
      if (I.scale) {
        resizeTexture(
          O,
          (I.flippW ? H : F) / config.worldUV,
          (I.flippW ? F : H) / config.worldUV,
          I.scale,
        );
      }
      P.push(O);
    }
    if (E[3]) {
      (O = new THREE.PlaneGeometry(1, 1)).rotateX(Math.PI / 2);
      if (I.flippW) {
        O.rotateY(Math.PI / 2);
      }
      O.translate(0, 0, 0);
      O.faces[0].vertexColors = [M, M, M];
      O.faces[1].vertexColors = [M, M, M];
      if (I.scale) {
        resizeTexture(
          O,
          (I.flippW ? H : F) / config.worldUV,
          (I.flippW ? F : H) / config.worldUV,
          I.scale,
        );
      }
      P.push(O);
    }
    if (E[4]) {
      O = new THREE.PlaneGeometry(1, 1);
      if (I.flipp) {
        O.rotateZ(Math.PI / 2);
      }
      O.translate(0, 0.5, 0.5);
      O.faces[0].vertexColors = [L, M, L];
      O.faces[1].vertexColors = [M, M, L];
      if (I.scale) {
        resizeTexture(
          O,
          (I.flipp ? G : F) / config.worldUV,
          (I.flipp ? F : G) / config.worldUV,
          I.scale,
        );
      }
      P.push(O);
    }
    if (E[5]) {
      (O = new THREE.PlaneGeometry(1, 1)).rotateY(Math.PI);
      if (I.flipp) {
        O.rotateZ(Math.PI / 2);
      }
      O.translate(0, 0.5, -0.5);
      O.faces[0].vertexColors = [L, M, L];
      O.faces[1].vertexColors = [M, M, L];
      if (I.scale) {
        resizeTexture(
          O,
          (I.flipp ? G : F) / config.worldUV,
          (I.flipp ? F : G) / config.worldUV,
          I.scale,
        );
      }
      P.push(O);
    }
    for (K = 0; K < P.length; K++) {
      v.merge(P[K], new THREE.Matrix4());
    }
    if (I && I.useScale) {
      v.scale(F, G, H);
      v.translate(0, -G / 2, 0);
    }
    A[J] = v;
  }
  return v;
};
var B = [];
module.exports.generateCone = function (E, F) {
  var G =
    (F.useScale || "u") +
    (F.closC || "c") +
    (F.sides || "s") +
    (F.colr == null ? "co" : F.colr) +
    (F.dark || "d") +
    (F.vNoise || "v");
  if (!(v = B[G])) {
    v = new THREE.ConeGeometry(1, 1, F.sides || 10, 1, !F.closC);
    if (F && !F.useScale) {
      v.translate(0, 0.5, 0);
    }
    if (F && F.vNoise) {
      var H;
      for (var I = 0; I < v.vertices.length; ++I) {
        H = Math.random() * F.vNoise;
        v.vertices[I].x += H;
        v.vertices[I].y += H;
        v.vertices[I].z += H;
      }
      v.verticesNeedUpdate = true;
    }
    module.exports.colorize(
      v,
      null,
      module.exports.getColor(F.colr || 16777215, F.dark || 1),
    );
    B[G] = v;
  }
  return v;
};
var C = [];
module.exports.generateSphere = function (E, F, G, H) {
  var I =
    (H.scale ? E + "_" + F + "_" + G + "_" : "") +
    (H.colr == null ? "c" : H.colr) +
    (H.scale || "s") +
    (H.useScale || "u") +
    (H.vNoise || "v") +
    (H.coat || "o");
  if (!(v = C[I])) {
    H.colr = H.colr == null ? 16777215 : H.colr;
    v = new THREE.SphereGeometry(1, 12, 8);
    if (H && H.vNoise) {
      var J;
      for (var K = 0; K < v.vertices.length; ++K) {
        J = Math.random() * H.vNoise;
        v.vertices[K].x += J;
        v.vertices[K].y += J;
        v.vertices[K].z += J;
      }
      v.verticesNeedUpdate = true;
    }
    if (H && H.useScale) {
      v.scale(E / 2, F / 2, G / 2);
    }
    module.exports.colorize(
      v,
      null,
      module.exports.getColor(H.colr || 16777215, H.dark || 1),
    );
    if (H.coat) {
      for (K = 0; K < v.faces.length; ++K) {
        if (v.faces[K].normal.y >= 0.5) {
          var L = module.exports.getColor(H.coat);
          v.faces[K].vertexColors[0] = L;
          v.faces[K].vertexColors[1] = L;
          v.faces[K].vertexColors[2] = L;
        }
      }
    }
    C[I] = v;
  }
  return v;
};
var D = [];
module.exports.generateCylinder = function (E) {
  var F =
    (E.colr == null ? "c" : E.colr) +
    (E.useScale || "u") +
    (E.sides || "s") +
    (E.open || "o") +
    (E.vNoise || "v");
  if (!(v = D[F])) {
    E.colr = E.colr == null ? 16777215 : E.colr;
    v = new THREE.CylinderGeometry(1, 1, 1, E.sides || 12, 1, E.open || false);
    if (E && E.vNoise) {
      var G;
      for (var H = 0; H < v.vertices.length; ++H) {
        G = Math.random() * E.vNoise;
        v.vertices[H].x += G;
        v.vertices[H].y += G;
        v.vertices[H].z += G;
      }
      v.verticesNeedUpdate = true;
    }
    if (E && !E.useScale) {
      v.translate(0, 0.5, 0);
    }
    module.exports.colorize(
      v,
      null,
      module.exports.getColor(E.colr || 16777215, 1),
    );
    D[F] = v;
  }
  return v;
};
